<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App"
  };
</script>

<style>
  @import "../common/css/common.css";

  #app {
    height: 100vh;
  }

  .el-image-viewer__close {
    color: red;
    top: 60px;
    right: 60px;
  }
</style>
